module.exports = __webpack_public_path__ + "static/media/img-horizontal-buildings@3x.f8fb13ef.png";